var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "zoom-org" }, [
    _vm.zoomCount
      ? _c(
          "div",
          [
            _c("p", [_c("em", [_vm._v(_vm._s(_vm.information))])]),
            _vm._v(" "),
            _vm._l(_vm.zooms, function(zoom) {
              return _c("span", { staticClass: "block" }, [
                _c("a", { attrs: { target: "_blank", href: zoom.zoom_link } }, [
                  _vm._v(_vm._s(zoom.organization))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "delimiter" }, [_vm._v(" / ")])
              ])
            }),
            _vm._v(" "),
            _c("hr")
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }